import { useAuthUserStore } from "@/stores/authUser";

export default function redirectParents() {
    return () => {
        const authUserStore = useAuthUserStore();
        const u = authUserStore.user;

        if (u && (u.type === "parent" || u.logged_in_parent)) {
            return {
                name: "launch"
            };
        }
    };
}
